window.addEventListener('DOMContentLoaded', function() {
    console.log('page - custom js is running');
    
    let featuredProjectsSlider = this.document.querySelector('.featured-projects-slides');

    if(featuredProjectsSlider) {

        let sliderSettings = {
            arrows: true,
            dots: false,
            infinite: false,
            speed: 400,
            slidesToShow: 4,
            slidesToScroll: 4,
            nextArrow: '#arrow-next',
            prevArrow: '#arrow-prev',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, 
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },            
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        $(featuredProjectsSlider).slick(sliderSettings);
    }
});